export const Endpoints = {
	auth: {
		login: "/auth/login",
		requestNewPassword: "/auth/email",
		changePassword: "/auth/restore/",
	},
	admin: {
		getInfo: "/admin/",
		createAdmin: "/admin/",
		getProyectsById: "/project/inmersys/enterprise/",
	},
	enterprise: {
		create: "/enterprise/",
		getAll: "/enterprise/all",
		disabed: "/enterprise/",
	},
	gruop: {
		create: "/learning-group",
		getAllByProyectId: "/learning-group/project/",
        deletegroup: "/learning-group/",
	},
	project: {
		allProjectsForId: "/project/enterprise",
		allresponsesbyproyectid: "/learning-answer/",
		allresponsesTrainingByProyectid: "/trainig-answer/",
		createProyect: "/project/",
		detailsProyecstbyEnterpiseId: "/project/completeData/",
		trainingDetailsProyecstbyEnterpiseId: "/project/completeData/",
	},
	student: {
		createone: "/student/",
		createMany: "/student/many",
		editStudent: "/student",
		deletemany: "/student/deleteMany",
	},
	local: {
		createAnswer: "/training/new",
	},
	responses: {
		addManyTraining: "/trainig-answer/addMany",
	},
};
